import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/SupportBar/SupportBar.jsx");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
